/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface DataPointRequestWithRangeDto
 */
export interface DataPointRequestWithRangeDto {
    /**
     * 
     * @type {string}
     * @memberof DataPointRequestWithRangeDto
     */
    evaluationResultId: string;
    /**
     * 
     * @type {number}
     * @memberof DataPointRequestWithRangeDto
     */
    numberOfPrecedingPoints: number;
    /**
     * 
     * @type {number}
     * @memberof DataPointRequestWithRangeDto
     */
    numberOfSubsequentPoints: number;
    /**
     * 
     * @type {string}
     * @memberof DataPointRequestWithRangeDto
     */
    $type?: DataPointRequestWithRangeDtoTypeEnum;
}


/**
 * @export
 */
export const DataPointRequestWithRangeDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoDataPointRequestWithRangeDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.DataPointRequestWithRangeDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DataPointRequestWithRangeDtoTypeEnum = typeof DataPointRequestWithRangeDtoTypeEnum[keyof typeof DataPointRequestWithRangeDtoTypeEnum];



/**
 * Check if a given object implements the DataPointRequestWithRangeDto interface.
 */
export function instanceOfDataPointRequestWithRangeDto(value?: unknown): value is DataPointRequestWithRangeDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DataPointRequestWithRangeDtoTypeEnum)[0];
}

export function DataPointRequestWithRangeDtoFromJSON(json: any): DataPointRequestWithRangeDto {
    return DataPointRequestWithRangeDtoFromJSONTyped(json, false);
}

export function DataPointRequestWithRangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPointRequestWithRangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'evaluationResultId': json['evaluationResultId'],
        'numberOfPrecedingPoints': json['numberOfPrecedingPoints'],
        'numberOfSubsequentPoints': json['numberOfSubsequentPoints'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DataPointRequestWithRangeDtoToJSON(value?: DataPointRequestWithRangeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'evaluationResultId': value['evaluationResultId'],
        'numberOfPrecedingPoints': value['numberOfPrecedingPoints'],
        'numberOfSubsequentPoints': value['numberOfSubsequentPoints'],
        '$type': value['$type'],
    });
}

